export function FieldLabel({
  label,
  error,
  children,
}: {
  label: string;
  error?: string | false;
  children: React.ReactNode;
}) {
  return (
    <label className="block text-xs font-medium">
      {label}
      <div className="mt-1">{children}</div>
      {error && <span className="block text-red-600 mt-1">{error}</span>}
    </label>
  );
}
